module.exports = __webpack_public_path__ + "static/media/p04.e929aec1.jpg";